export const PROXY_SESSION_HEADER = 'X-Proxy-Session';

const PROXY_SESSION_STORAGE_PREFIX = 'proxy#';

const LAST_AUTH_USER_SUFFIX = '.LastAuthUser';

/** Cognito username Amplify is using for the portal session on screen. */
const currentAuthUsername = (): string | undefined => {
  const key = Object.keys(window.localStorage).find(
    (storageKey) =>
      storageKey.startsWith('CognitoIdentityServiceProvider.') &&
      storageKey.endsWith(LAST_AUTH_USER_SUFFIX),
  );
  if (!key) {
    return undefined;
  }
  return window.localStorage.getItem(key) || undefined;
};

/**
 * True when the portal session on screen was signed in through the admin proxy.
 * Other saved accounts can keep their own markers without affecting this one.
 */
export const readIsProxySession = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const username = currentAuthUsername();
  if (!username) {
    return false;
  }
  return (
    window.localStorage.getItem(
      `${PROXY_SESSION_STORAGE_PREFIX}${username}`,
    ) === 'true'
  );
};

export const proxySessionHeaders = (): Record<string, string> =>
  readIsProxySession() ? { [PROXY_SESSION_HEADER]: 'true' } : {};

/** Drops every proxy marker, including one left behind by a session that ended without logout. */
export const clearProxySessionMarkers = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  Object.keys(window.localStorage)
    .filter((key) => key.startsWith(PROXY_SESSION_STORAGE_PREFIX))
    .forEach((key) => window.localStorage.removeItem(key));
};

/**
 * Records this sign-in only. A normal sign-in drops this username's marker.
 * Markers for other accounts that are still signed in stay put.
 */
export const recordProxySession = (
  username: string,
  isProxy: boolean,
): void => {
  if (typeof window === 'undefined' || !username) {
    return;
  }
  const key = `${PROXY_SESSION_STORAGE_PREFIX}${username}`;
  if (isProxy) {
    window.localStorage.setItem(key, 'true');
    return;
  }
  window.localStorage.removeItem(key);
};
